const CoreSetting = {
  paysystemTable: {
    id: 'ID',
    name: 'Имя',
    active: 'Активный',
    paysystems: 'Платежные системы',
    showing: 'показывается',
    noPaysystemsFound: 'Платежные системы не найдены',
  },
  emailTemplatesTable: {
    id: 'ID',
    name: 'Имя',
    active: 'Активный',
    emailTemplates: 'Уведомления по электронной почте',
    showing: 'показывается',
    noEmailTemplatesFound: 'Шаблоны электронной почты не найдены',
  },
  productTable: {
    name: 'Имя',
    active: 'Активный',
    products: 'Продукты',
    showing: 'показывается',
    noProductsFound: 'Продукты не найдены',
  },
};

export default CoreSetting;
